export { default as BallzVault } from './BallzVault.json';
export { default as ERC20 } from './ERC20.json';
export { default as WCRO } from './WCRO.json';
